
<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="'Back'" (addEvent)="backToEnquiries()"></app-breadcrumb>
    <div class="container-fluid">
        <!-- Edit Enquiry Form -->
        <div class="row">
            <div class="col-xl-12">
                <div class="card">
                    <div class="card-header border-0">
                        <h4 class="card-title">Edit Enquiry</h4>
                    </div>
                    <div class="card-body pt-0">
                        <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()" autocomplete="off">
                            <div class="row">
                                <!-- Property (Dropdown) -->
                                <div class="col-xl-6 mb-3">
                                    <label class="form-label">Property <span class="text-danger">*</span></label>
                                    <ng-select
                                        ngDefaultControl
                                        [items]="propertiesItems"
                                        bindValue="value"
                                        bindLabel="label"
                                        placeholder="Select Property"
                                        class="select2"
                                        formControlName="property_id"
                                        [typeahead]="searchProperty$"
                                        [virtualScroll]="true"
                                        (scrollToEnd)="onPropertyScrollEnd()"
                                        [class.is-invalid]="isFieldInvalid('property_id')"
                                    >
                                        <ng-template #template let-data="data">{{ data.label }}</ng-template>
                                    </ng-select>
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('property_id')">
                                        Property is required
                                    </div>
                                </div>

                                <!-- Property Type -->
                                <div class="col-xl-6 mb-3">
                                    <label class="form-label">Property Type</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="property_type"
                                        placeholder="Enter property type" />
                                </div>

                                <!-- Name -->
                                <div class="col-xl-6 mb-3">
                                    <label class="form-label">Name <span class="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="name"
                                        placeholder="Enter name"
                                        [class.is-invalid]="isFieldInvalid('name')" />
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('name')">
                                        Name is required
                                    </div>
                                </div>

                                <!-- Phone -->
                                <div class="col-xl-6 mb-3">
                                    <label class="form-label">Phone <span class="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="phone"
                                        placeholder="Enter phone"
                                        [class.is-invalid]="isFieldInvalid('phone')" />
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('phone')">
                                        Phone is required
                                    </div>
                                </div>

                                <!-- Email -->
                                <div class="col-xl-6 mb-3">
                                    <label class="form-label">Email</label>
                                    <input
                                        type="email"
                                        class="form-control"
                                        formControlName="email"
                                        placeholder="Enter email"
                                        [class.is-invalid]="isFieldInvalid('email')" />
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
                                        Invalid email format
                                    </div>
                                </div>

                                <!-- Locality -->
                                <div class="col-xl-6 mb-3">
                                    <label class="form-label">Locality</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="locality"
                                        placeholder="Enter locality" />
                                </div>

                                <!-- City -->
                                <div class="col-xl-6 mb-3">
                                    <label class="form-label">City</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="city"
                                        placeholder="Enter city" />
                                </div>

                                <!-- State -->
                                <div class="col-xl-6 mb-3">
                                    <label class="form-label">State</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="state"
                                        placeholder="Enter state" />
                                </div>

                                <!-- Amount -->
                                <div class="col-xl-6 mb-3">
                                    <label class="form-label">Amount</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="amount"
                                        placeholder="Enter amount" />
                                </div>

                                <!-- Bed Rooms -->
                                <div class="col-xl-6 mb-3">
                                    <label class="form-label">Bed Rooms</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="bath_room"
                                        placeholder="Enter required bed rooms" />
                                </div>

                                <!-- Looking For -->
                                <div class="col-12 mb-3">
                                    <label class="form-label">Looking For</label>
                                    <textarea
                                        class="form-control"
                                        formControlName="looking_for"
                                        rows="3"
                                        placeholder="Enter what the customer is looking for"></textarea>
                                </div>

                                <!-- Status -->
                                <div class="col-xl-6 mb-3">
                                    <label class="form-label">Status</label>
                                    <select
                                        class="form-select"
                                        formControlName="status">
                                        <option *ngFor="let option of statusOptions" [value]="option.value">
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>

                                <!-- Follow Up Date -->
                                <div class="col-xl-6 mb-3">
                                    <label class="form-label">Follow Up Date</label>
                                    <input
                                        type="date"
                                        class="form-control"
                                        formControlName="follow_up_date" />
                                </div>
                            </div>

                            <!-- Form Actions -->
                            <div>
                                <button class="btn btn-primary btn-sm ms-1 me-3" type="submit"
                                        [disabled]="enquiryForm.invalid || loadingService.isLoading()">
                                    Update Enquiry
                                </button>
                                <button class="btn btn-danger light btn-sm me-1" type="button" (click)="backToEnquiries()">
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Comments Table Section -->
        <div class="row" *ngIf="checkViewCommentPermission">
            <div class="col-xl-12">
                <div class="card">
                    <div class="card-header border-0 d-flex justify-content-between align-items-center">
                        <h4 class="card-title">Follow Up History</h4>
                        <button *ngIf="checkAddCommentPermission" class="btn btn-primary btn-sm" (click)="openCommentDrawer()">
                            <i class="fa fa-plus me-2"></i>Add Comment
                        </button>
                    </div>
                    <div class="card-body pt-0">
                        <div class="table-responsive">
                            <table class="table table-responsive-md">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Added By</th>
                                        <th>Comment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let comment of comments">
                                        <td>{{ comment.created_at | date:'dd-MM-yyyy' }}</td>
                                        <td>{{ comment.created_by }}</td>
                                        <td [innerHTML]="comment.comment"></td>
                                    </tr>
                                    <tr *ngIf="comments.length === 0">
                                        <td colspan="3" class="text-center">No comments available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<!-- Add Comment Drawer -->
<div #addCommentDrawer class="offcanvas offcanvas-end customeoff {{ drawerOpen ? 'show':''}}" tabindex="-1" id="addCommentDrawer" data-bs-backdrop="static">
    <div class="offcanvas-header">
        <h5 class="modal-title" id="#gridSystemModal">Add Comment</h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" (click)="closeCommentDrawer()">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
    <div class="offcanvas-body">
        <div class="container-fluid">
            <form [formGroup]="commentForm" (ngSubmit)="saveComment()" autocomplete="off">
                <div class="row">
                    <div class="col-xl-12 mb-3">
                        <label for="comment" class="form-label">Comment<span class="text-danger">*</span></label>
                        <ckeditor [editor]="Editor" formControlName="comment"></ckeditor>
                        <div *ngIf="commentForm?.get('comment')?.invalid && commentForm?.get('comment')?.touched" class="required">
                            Comment is required
                        </div>
                    </div>
                </div>
                <div>
                    <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="commentForm.invalid || loadingService.isLoading()">Save</button>
                    <button class="btn btn-danger light me-1" type="button" (click)="closeCommentDrawer()">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>
@if(drawerOpen){
    <div class="offcanvas-backdrop fade show" (click)="closeCommentDrawer()"></div>
}
